//import {format} from 'date-fns';
import { ColumnFilter } from './ColumnFilter';



function dateFormat(value){
	let objectDate = new Date(value);
	let day = ("0" + (objectDate.getDate() + 1)).slice(-2);
	let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
	let year = objectDate.getFullYear();
	
	return  day + "/" + month + "/" + year;	 
	
}


   

export const COLUMNS = [
	{
		Header : 'OrderID',
		Footer : 'OrderID',
		accessor: 'OrderID',
		Filter: ColumnFilter,
		//isVisible:"false"
		//disableFilters: true,

	},
	{  
		Header : 'اسم الزبون',
		Footer : 'First Name',
		accessor: 'CustomerName',
		Filter: ColumnFilter,
	},
	{  
		Header : 'تاريخ الطلبية',
		Footer : 'First Name',
		accessor: 'OrderDate',
		Filter: ColumnFilter,
	},
	{  
		Header : 'هاتف الزبون',
		Footer : 'First Name',
		accessor: 'PhoneNumber',
		Filter: ColumnFilter,
	},
	{  
		Header : 'الكمية',
		Footer : 'First Name',
		accessor: 'MaxQuantity',
		Filter: ColumnFilter,
	},
	// {  
	// 	Header : 'الصالة',
	// 	Footer : ' Notes',
	// 	accessor: 'HallName',
	// 	Filter: ColumnFilter,
	// },
	{  
    Header : 'الصالة',
    Footer : 'Notes',
    accessor: (row) => {
        return row.HallName ? row.HallName : row.Address;
    },
    Filter: ColumnFilter,
},
	{  
		Header : ' العربون',
		Footer : ' Notes',
		accessor: 'Prepay',
		Filter: ColumnFilter,
	},
	{
		Header : 'الحالة',
		Footer : 'Email Id',
		accessor: 'Status',
		Filter: ColumnFilter,
	},
	{
		Header : 'حالة الدفع',
		Footer : 'Email Id',
		accessor: 'Paystatus',
		Filter: ColumnFilter,
	},
	 
	
]

export const GROUPED_COLUMNS = [
	{
		Header : 'Id',
		Footer : 'Id',
		accessor: 'id'
	},
	{
		Header : 'Name',
		Footer : 'Name',
		columns: [
			{
				Header : 'First Name',
				Footer : 'First Name',
				accessor: 'first_name'
			},
			{
				Header : 'Last Name',
				Footer : 'Last Name',
				accessor: 'last_name'
			},
		]
	},
	{
		Header: 'Info',
		Footer: 'Info',
		columns: [
			{
				Header : 'Date of  Birth',
				Footer : 'Date of  Birth',
				accessor: 'date_of_birth'
			},
			{
				Header : 'Country',
				Footer : 'Country',
				accessor: 'country',
			},
			{
				Header : 'Phone',
				Footer : 'Phone',
				accessor: 'phone'
			},
		]
	},
]